import React, { Component } from "react";
import './contactSection.css';

class ContactSection extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="contactRoot">
                <div className="contactWrapper">
                    <div className="formContainer">
                        <h1>Schickt uns ne Nachricht!</h1>
                        <form action="scripts/form-carousel_a43d.php" method="POST">
                            <div>
                                <input type="text" placeholder="Name" name="name" required></input>
                            </div>
                            <div>
                                <input type="email" placeholder="E-Mail" name="email" required></input>
                            </div>
                            <div>
                                <textarea placeholder="Nachricht eingeben." rows="4" cols="50" name="message" required></textarea>
                            </div>
                            <div>
                                <input id="submitBtn" type="submit" value="Senden" wfd-invisible="true"></input>
                            </div>
                        </form>
                    </div>
                    
                </div>
            </div>
        );
    }
}
export default ContactSection;